const defaultCssClass = "info-item";

const InfoItem = ({ label, value, cssClass, style }) => {
    return (
        <div className={`${cssClass || defaultCssClass}`} style={style}>
            <label>{label}</label>
            <span>{value}</span>
        </div>
    )
};

export default InfoItem;